import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { Button, Container, Modal, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectPersonDetails, updateOrganizationContact } from '../../redux/reducers/organizationReducer';

export default function EditContactModal({ handleClose, contactId }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const details = useSelector((state) => selectPersonDetails(state, contactId));
  const [contactDetails, setContactDetails] = useState({});
  const [editMode, setEditMode] = useState(false);

  const handleTextFields = (event) => {
    const { name, value } = event.target;
    const newDetails = { ...contactDetails };
    newDetails[name] = value;
    setContactDetails(newDetails);
  };

  const handleSave = () => {
    dispatch(updateOrganizationContact(contactDetails));
    handleClose();
  };

  const handleDelete = () => {
    // TODO: implement when functionality is designed
  };

  const toggleEdit = () => {
    setEditMode(!editMode);
  };

  useEffect(() => {
    setContactDetails({ ...details });
  }, [details]);

  return (
    <Modal open>
      <Container variant="settingsModal" sx={{ display: 'flex', flexDirection: 'column' }} disableGutters>
        <Container variant="formContainer" disableGutters>
          <Stack direction="column" spacing={2}>
            <Typography variant="h6">{t(`person.contact.${editMode ? 'edit' : 'view'}`)}</Typography>
            {editMode ? (
              <TextField
                id="name"
                name="name"
                variant="outlined"
                label={t('person.modal.name')}
                value={contactDetails.name}
                onChange={(event) => handleTextFields(event)}
              />
            ) : (
              <Stack>
                <Typography variant="body1">{t('person.modal.name')}</Typography>
                <Typography variant="body2">{contactDetails.name}</Typography>
              </Stack>
            )}
            {editMode ? (
              <TextField
                name="email"
                variant="outlined"
                label={t('person.modal.email')}
                value={contactDetails.email}
                onChange={(event) => handleTextFields(event)}
              />
            ) : (
              <Stack>
                <Typography variant="body1">{t('person.modal.email')}</Typography>
                <Typography variant="body2">{contactDetails.email}</Typography>
              </Stack>
            )}
            {editMode ? (
              <TextField
                id="phone"
                name="phone"
                variant="outlined"
                label={t('person.modal.phone')}
                value={contactDetails.phone}
                onChange={(event) => handleTextFields(event)}
              />
            ) : (
              <Stack>
                <Typography variant="body1">{t('person.modal.phone')}</Typography>
                <Typography variant="body2">{contactDetails.phone || '-'}</Typography>
              </Stack>
            )}
          </Stack>
        </Container>
        <Container variant="buttonRow" disableGutters>
          {editMode ? (
            <Stack direction="row" justifyContent="flex-end">
              {/* TODO: return when functionality is designed, remember to change containing stack's justify */}
              {/* <Button onClick={handleDelete} variant="contained" startIcon={<DeleteIcon />}>{t('person.contact.delete')}</Button> */}
              <Stack direction="row">
                <Button id='close' variant="text" startIcon={<ClearIcon />} onClick={() => handleClose()}>
                  {t('person.modal.buttonCancel')}
                </Button>
                <Button id='save' variant="contained" startIcon={<SaveIcon />} onClick={() => handleSave()}>{t('organization.buttonSaveEdit')}</Button>
              </Stack>
            </Stack>
          ) : (
            <Stack direction="row" justifyContent="flex-end">
              <Button variant="text" startIcon={<ClearIcon />} onClick={() => handleClose(undefined)}>
                {t('person.modal.buttonClose')}
              </Button>
              <Button variant="contained" startIcon={<EditIcon />} onClick={toggleEdit}>
                {t('person.contact.edit')}
              </Button>
            </Stack>
          )}
        </Container>
      </Container>
    </Modal>
  );
}
